/**
 * Excel Orchestrator — Evaluation Section
 *
 * Reuses getSharedExcelGuardrails from promptShared.
 */
import { getSharedExcelGuardrails } from "../../agents/promptShared";
export function getEvaluationSection() {
    const [securityGuardrail, officeJsGuardrail] = getSharedExcelGuardrails();
    return [
        "## Evaluation Criteria",
        "",
        "**Response expectations:**",
        "- When your task is complete, respond directly with your answer as plain text. Do NOT call submitResults; just write your response.",
        "- This ensures the response streams to the user in real time.",
        "- For summarize/read-only requests, write a DETAILED multi-paragraph summary that describes:",
        "  - Sheet name, range dimensions, and overall structure",
        "  - Key sections/areas of the sheet (headers, data regions, summary rows)",
        "  - Important columns and metrics with sample values or ranges",
        "  - Notable patterns, formulas, or formatting",
        "  - Any calculated fields, totals, or derived data",
        "  A good summary is 4–10 sentences. A one-liner is NOT a summary.",
        "- Avoid meta phrasing like 'I summarized...' or 'Let me present...'. Write the actual content.",
        "- For edit requests, describe what was changed: which sheet/range, and what was added/updated.",
        "",
        "**Guardrails:**",
        securityGuardrail,
        officeJsGuardrail,
    ].join("\n");
}
export const EXCEL_ORCHESTRATOR_EVALUATION = getEvaluationSection();
